import Vue from 'vue'
import Router from 'vue-router'
import login from './views/login'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect:'example'
    },
    {
      path: '/example',
      component: (resolve) => require(['./views/example/example'], resolve),
      meta: {
        title: '示例'
      }
    },
    {
      path: '/views',
      meta:{auth:true},
      component:(resolve) => require(['./views/Home'], resolve),
      children:[{
          path:'/mainPage',
          component:(resolve) => require(['./views/mainPage'], resolve),
          meta: { title: '意见反馈' }
      },
      {
        path: '/Optionadd',
        component: (resolve) => require(['./views/option/Optionadd'], resolve),
        meta: { title: '意见反馈' }
      },
    ]
    },
    // {
    //   path: '/login',
    //   component:login
    // },
         
  ],
})
